export const errors = {
  generic: 'Oops something went wrong, try again. If the problem persists feel free to contact us.'
};

export default errors;
